module.exports = __webpack_public_path__ + "static/media/ijs-tapas-1.76a28b15.jpeg";